export const PROBLEM_HANDS = [
  {
    id: "ph1",
    title: "Declarer #1",
    deal: {
      hands: {
        N: [
          { suit: "S", rank: "A" }, { suit: "S", rank: "3" }, { suit: "S", rank: "2" },
          { suit: "H", rank: "A" }, { suit: "H", rank: "5" }, { suit: "H", rank: "4" },
          { suit: "D", rank: "7" },
          { suit: "C", rank: "A" }, { suit: "C", rank: "K" }, { suit: "C", rank: "Q" },
          { suit: "C", rank: "T" }, { suit: "C", rank: "5" }, { suit: "C", rank: "4" },
        ],
        E: [
          { suit: "S", rank: "8" }, { suit: "S", rank: "Q" }, { suit: "S", rank: "J" },
          { suit: "H", rank: "2" },
          { suit: "D", rank: "A" }, { suit: "D", rank: "Q" }, { suit: "D", rank: "J" },
          { suit: "D", rank: "9" }, { suit: "D", rank: "8" }, { suit: "D", rank: "5" },
          { suit: "D", rank: "4" },
          { suit: "C", rank: "3" }, { suit: "C", rank: "2" },
        ],
        S: [
          { suit: "S", rank: "T" }, { suit: "S", rank: "9" }, { suit: "S", rank: "7" },
          { suit: "S", rank: "6" }, { suit: "S", rank: "5" }, { suit: "S", rank: "4" },
          { suit: "H", rank: "8" }, { suit: "H", rank: "7" },
          { suit: "D", rank: "T" }, { suit: "D", rank: "6" }, { suit: "D", rank: "3" },
          { suit: "D", rank: "2" },
          { suit: "C", rank: "7" },
        ],
        W: [
          { suit: "S", rank: "K" },
          { suit: "H", rank: "K" }, { suit: "H", rank: "Q" }, { suit: "H", rank: "J" },
          { suit: "H", rank: "T" }, { suit: "H", rank: "9" }, { suit: "H", rank: "6" },
          { suit: "H", rank: "3" },
          { suit: "D", rank: "K" },
          { suit: "C", rank: "J" }, { suit: "C", rank: "9" }, { suit: "C", rank: "8" },
          { suit: "C", rank: "6" },
        ],
      },
      dealer: "E",
      vul: "",
    },
    auction: [
      { seat: "E", call: { level: 3, strain: "D" } },
      { seat: "S", call: { kind: "pass" } },
      { seat: "W", call: { kind: "pass" } },
      { seat: "N", call: { kind: "double" } },
      { seat: "E", call: { kind: "pass" } },
      { seat: "S", call: { level: 3, strain: "S" } },
      { seat: "W", call: { kind: "pass" } },
      { seat: "N", call: { level: 4, strain: "D" } },
      { seat: "E", call: { kind: "pass" } },
      { seat: "S", call: { level: 4, strain: "S" } },
      { seat: "W", call: { kind: "pass" } },
      { seat: "N", call: { kind: "pass" } },
      { seat: "E", call: { kind: "pass" } },
    ],
    contract: { level: 4, strain: "S", declarer: "S", doubled: 0 },
    lead: { seat: "W", card: { suit: "H", rank: "K" } },
    intro: [
      "With the south hand, you simply bid 3S over the double. Some people might be tempted to bid 4S with 6 cards despite such few points. The biggest problem is that partner will not know you're so weak - if they raise your 4S to 6S, how are you feeling?",
      "Partner's 4D bid was a generic bid. It applies after the opponents preempt. It says 'I obviously have a good hand, I'm forcing the bidding up, but I don't have primary spade support (4 cards), I have a hand which might be okay for spades (3 card support) but otherwise I have another suit'.",
      "After all that the contract is 4S, your play.",
    ],
    solution: "(Solution to be added.)",
  },
  {
    id: "ph2",
    title: "Declarer #2",
    deal: {
      hands: {
        N: [
          { suit: "S", rank: "A" }, { suit: "S", rank: "3" }, { suit: "S", rank: "2" },
          { suit: "H", rank: "A" }, { suit: "H", rank: "K" }, { suit: "H", rank: "J" },
          { suit: "H", rank: "9" }, { suit: "H", rank: "4" },
          { suit: "D", rank: "A" }, { suit: "D", rank: "4" },
          { suit: "C", rank: "A" }, { suit: "C", rank: "5" }, { suit: "C", rank: "2" },
        ],
        E: [
          { suit: "S", rank: "K" }, { suit: "S", rank: "J" }, { suit: "S", rank: "6" },
          { suit: "H", rank: "5" },
          { suit: "D", rank: "9" }, { suit: "D", rank: "8" }, { suit: "D", rank: "6" },
          { suit: "D", rank: "3" }, { suit: "D", rank: "2" },
          { suit: "C", rank: "Q" }, { suit: "C", rank: "J" }, { suit: "C", rank: "T" },
          { suit: "C", rank: "3" },
        ],
        S: [
          { suit: "S", rank: "Q" }, { suit: "S", rank: "T" }, { suit: "S", rank: "9" },
          { suit: "S", rank: "8" }, { suit: "S", rank: "5" }, { suit: "S", rank: "4" },
          { suit: "H", rank: "Q" }, { suit: "H", rank: "8" }, { suit: "H", rank: "3" },
          { suit: "H", rank: "2" },
          { suit: "D", rank: "7" }, { suit: "D", rank: "5" },
          { suit: "C", rank: "K" },
        ],
        W: [
          { suit: "S", rank: "7" },
          { suit: "H", rank: "T" }, { suit: "H", rank: "7" }, { suit: "H", rank: "6" },
          { suit: "D", rank: "K" }, { suit: "D", rank: "Q" }, { suit: "D", rank: "J" },
          { suit: "D", rank: "T" },
          { suit: "C", rank: "9" }, { suit: "C", rank: "8" }, { suit: "C", rank: "7" },
          { suit: "C", rank: "6" }, { suit: "C", rank: "4" },
        ],
      },
      dealer: "",
      vul: "",
    },
    auction: [],
    contract: { level: 5, strain: "H", declarer: "S", doubled: 0 },
    lead: { seat: "W", card: { suit: "D", rank: "Q" } },
    intro: [
      "After a long and artificial auction where the opponents didn't bid at all, the pair that played this hand ended in 5♥. The hand looks like it might make 6, yet your goal is to safely make 5. What is the best way to try make this contract?",
    ],
    solution: "(Solution to be added.)",
  },
  {
    id: "ph3",
    title: "Declarer #3",
    deal: {
      hands: {
        N: [
          { suit: "S", rank: "8" }, { suit: "S", rank: "5" }, { suit: "S", rank: "2" },
          { suit: "H", rank: "Q" }, { suit: "H", rank: "T" }, { suit: "H", rank: "9" },
          { suit: "D", rank: "A" }, { suit: "D", rank: "9" }, { suit: "D", rank: "7" },
          { suit: "D", rank: "5" }, { suit: "D", rank: "2" },
          { suit: "C", rank: "8" }, { suit: "C", rank: "4" },
        ],
        E: [
          { suit: "S", rank: "9" }, { suit: "S", rank: "3" },
          { suit: "H", rank: "A" }, { suit: "H", rank: "K" }, { suit: "H", rank: "J" },
          { suit: "H", rank: "8" }, { suit: "H", rank: "5" }, { suit: "H", rank: "3" },
          { suit: "D", rank: "J" }, { suit: "D", rank: "6" }, { suit: "D", rank: "4" },
          { suit: "C", rank: "J" }, { suit: "C", rank: "3" },
        ],
        S: [
          { suit: "S", rank: "A" }, { suit: "S", rank: "K" }, { suit: "S", rank: "J" },
          { suit: "S", rank: "7" }, { suit: "S", rank: "4" },
          { suit: "H", rank: "2" },
          { suit: "D", rank: "K" }, { suit: "D", rank: "8" }, { suit: "D", rank: "3" },
          { suit: "C", rank: "A" }, { suit: "C", rank: "K" }, { suit: "C", rank: "9" },
          { suit: "C", rank: "5" },
        ],
        W: [
          { suit: "S", rank: "Q" }, { suit: "S", rank: "T" }, { suit: "S", rank: "6" },
          { suit: "H", rank: "7" }, { suit: "H", rank: "6" }, { suit: "H", rank: "4" },
          { suit: "D", rank: "Q" }, { suit: "D", rank: "T" },
          { suit: "C", rank: "Q" }, { suit: "C", rank: "T" }, { suit: "C", rank: "7" },
          { suit: "C", rank: "6" }, { suit: "C", rank: "2" },
        ],
      },
      dealer: "E",
      vul: "",
    },
    auction: [
      { seat: "E", call: { level: 2, strain: "H" } },
      { seat: "S", call: { kind: "double" } },
      { seat: "W", call: { kind: "pass" } },
      { seat: "N", call: { level: 3, strain: "D" } },
      { seat: "E", call: { kind: "pass" } },
      { seat: "S", call: { level: 3, strain: "S" } },
      { seat: "W", call: { kind: "pass" } },
      { seat: "N", call: { level: 4, strain: "S" } },
      { seat: "E", call: { kind: "pass" } },
      { seat: "S", call: { kind: "pass" } },
      { seat: "W", call: { kind: "pass" } },
    ],
    contract: { level: 4, strain: "S", declarer: "S", doubled: 0 },
    lead: { seat: "W", card: { suit: "H", rank: "4" } },
    intro: [],
    solution: "(Solution to be added.)",
  },
  {
    id: "ph4",
    title: "Declarer #4",
    deal: {
      hands: {
        N: [
          { suit: "S", rank: "7" }, { suit: "S", rank: "5" }, { suit: "S", rank: "3" },
          { suit: "H", rank: "A" }, { suit: "H", rank: "4" }, { suit: "H", rank: "3" },
          { suit: "D", rank: "K" }, { suit: "D", rank: "J" }, { suit: "D", rank: "9" },
          { suit: "D", rank: "8" },
          { suit: "C", rank: "7" }, { suit: "C", rank: "5" }, { suit: "C", rank: "4" },
        ],
        E: [
          { suit: "S", rank: "Q" }, { suit: "S", rank: "J" }, { suit: "S", rank: "9" },
          { suit: "H", rank: "K" }, { suit: "H", rank: "7" }, { suit: "H", rank: "6" },
          { suit: "H", rank: "5" },
          { suit: "D", rank: "7" }, { suit: "D", rank: "6" },
          { suit: "C", rank: "J" }, { suit: "C", rank: "T" }, { suit: "C", rank: "8" },
          { suit: "C", rank: "6" },
        ],
        S: [
          { suit: "S", rank: "A" }, { suit: "S", rank: "K" }, { suit: "S", rank: "T" },
          { suit: "S", rank: "6" }, { suit: "S", rank: "4" }, { suit: "S", rank: "2" },
          { suit: "H", rank: "2" },
          { suit: "D", rank: "A" }, { suit: "D", rank: "Q" }, { suit: "D", rank: "T" },
          { suit: "C", rank: "K" }, { suit: "C", rank: "3" }, { suit: "C", rank: "2" },
        ],
        W: [
          { suit: "S", rank: "8" },
          { suit: "H", rank: "Q" }, { suit: "H", rank: "J" }, { suit: "H", rank: "T" },
          { suit: "H", rank: "9" }, { suit: "H", rank: "8" },
          { suit: "D", rank: "5" }, { suit: "D", rank: "4" }, { suit: "D", rank: "3" },
          { suit: "D", rank: "2" },
          { suit: "C", rank: "A" }, { suit: "C", rank: "Q" }, { suit: "C", rank: "9" },
        ],
      },
      dealer: "S",
      vul: "",
    },
    auction: [
      { seat: "S", call: { level: 1, strain: "S" } },
      { seat: "W", call: { level: 2, strain: "H" } },
      { seat: "N", call: { level: 2, strain: "S" } },
      { seat: "E", call: { level: 3, strain: "H" } },
      { seat: "S", call: { level: 4, strain: "S" } },
      { seat: "W", call: { kind: "pass" } },
      { seat: "N", call: { kind: "pass" } },
      { seat: "E", call: { kind: "pass" } },
    ],
    contract: { level: 4, strain: "S", declarer: "S", doubled: 0 },
    lead: { seat: "W", card: { suit: "H", rank: "Q" } },
    intro: [],
    solution: "(Solution to be added.)",
  },
  {
    id: "ph5",
    title: "Declarer #5",
    deal: {
      hands: {
        N: [
          { suit: "S", rank: "5" }, { suit: "S", rank: "4" },
          { suit: "H", rank: "K" }, { suit: "H", rank: "Q" }, { suit: "H", rank: "T" },
          { suit: "H", rank: "9" }, { suit: "H", rank: "8" }, { suit: "H", rank: "7" },
          { suit: "D", rank: "2" },
          { suit: "C", rank: "K" }, { suit: "C", rank: "J" }, { suit: "C", rank: "9" },
          { suit: "C", rank: "8" },
        ],
        E: [
          { suit: "S", rank: "3" }, { suit: "S", rank: "2" },
          { suit: "H", rank: "5" }, { suit: "H", rank: "4" }, { suit: "H", rank: "3" },
          { suit: "H", rank: "2" },
          { suit: "D", rank: "J" }, { suit: "D", rank: "9" }, { suit: "D", rank: "8" },
          { suit: "D", rank: "7" },
          { suit: "C", rank: "4" }, { suit: "C", rank: "3" }, { suit: "C", rank: "2" },
        ],
        S: [
          { suit: "S", rank: "A" }, { suit: "S", rank: "K" }, { suit: "S", rank: "J" },
          { suit: "S", rank: "T" }, { suit: "S", rank: "9" }, { suit: "S", rank: "8" },
          { suit: "H", rank: "A" }, { suit: "H", rank: "J" },
          { suit: "D", rank: "A" }, { suit: "D", rank: "6" }, { suit: "D", rank: "5" },
          { suit: "D", rank: "4" }, { suit: "D", rank: "3" },
        ],
        W: [
          { suit: "S", rank: "Q" }, { suit: "S", rank: "7" }, { suit: "S", rank: "6" },
          { suit: "H", rank: "6" },
          { suit: "D", rank: "K" }, { suit: "D", rank: "Q" }, { suit: "D", rank: "T" },
          { suit: "C", rank: "A" }, { suit: "C", rank: "Q" }, { suit: "C", rank: "T" },
          { suit: "C", rank: "7" }, { suit: "C", rank: "6" }, { suit: "C", rank: "5" },
        ],
      },
      dealer: "S",
      vul: "",
    },
    auction: [
      { seat: "S", call: { level: 1, strain: "S" } },
      { seat: "W", call: { level: 2, strain: "C" } },
      { seat: "N", call: { level: 2, strain: "H" } },
      { seat: "E", call: { kind: "pass" } },
      { seat: "S", call: { level: 3, strain: "S" } },
      { seat: "W", call: { kind: "pass" } },
      { seat: "N", call: { level: 4, strain: "S" } },
      { seat: "E", call: { kind: "pass" } },
      { seat: "S", call: { level: 6, strain: "S" } },
      { seat: "W", call: { kind: "pass" } },
      { seat: "N", call: { kind: "pass" } },
      { seat: "E", call: { kind: "pass" } },
    ],
    contract: { level: 6, strain: "S", declarer: "S", doubled: 0 },
    lead: { seat: "W", card: { suit: "D", rank: "K" } },
    intro: [],
    solution: "(Solution to be added.)",
  },
  {
    id: "ph6",
    title: "Declarer #6",
    deal: {
      hands: {
        N: [
          { suit: "S", rank: "7" }, { suit: "S", rank: "2" },
          { suit: "H", rank: "T" }, { suit: "H", rank: "7" }, { suit: "H", rank: "5" },
          { suit: "H", rank: "3" },
          { suit: "D", rank: "T" }, { suit: "D", rank: "9" }, { suit: "D", rank: "8" },
          { suit: "D", rank: "7" },
          { suit: "C", rank: "Q" }, { suit: "C", rank: "3" }, { suit: "C", rank: "2" },
        ],
        E: [
          { suit: "S", rank: "A" }, { suit: "S", rank: "J" }, { suit: "S", rank: "9" },
          { suit: "S", rank: "6" },
          { suit: "H", rank: "6" }, { suit: "H", rank: "4" }, { suit: "H", rank: "2" },
          { suit: "D", rank: "4" }, { suit: "D", rank: "3" },
          { suit: "C", rank: "J" }, { suit: "C", rank: "T" }, { suit: "C", rank: "9" },
          { suit: "C", rank: "8" },
        ],
        S: [
          { suit: "S", rank: "K" }, { suit: "S", rank: "4" },
          { suit: "H", rank: "A" }, { suit: "H", rank: "K" }, { suit: "H", rank: "Q" },
          { suit: "D", rank: "A" }, { suit: "D", rank: "Q" }, { suit: "D", rank: "J" },
          { suit: "D", rank: "2" },
          { suit: "C", rank: "A" }, { suit: "C", rank: "K" }, { suit: "C", rank: "5" },
          { suit: "C", rank: "4" },
        ],
        W: [
          { suit: "S", rank: "Q" }, { suit: "S", rank: "T" }, { suit: "S", rank: "8" },
          { suit: "S", rank: "5" }, { suit: "S", rank: "3" },
          { suit: "H", rank: "J" }, { suit: "H", rank: "9" }, { suit: "H", rank: "8" },
          { suit: "D", rank: "K" }, { suit: "D", rank: "6" }, { suit: "D", rank: "5" },
          { suit: "C", rank: "7" }, { suit: "C", rank: "6" },
        ],
      },
      dealer: "S",
      vul: "",
    },
    auction: [
      { seat: "S", call: { level: 2, strain: "C" } },
      { seat: "W", call: { kind: "pass" } },
      { seat: "N", call: { level: 2, strain: "D" } },
      { seat: "E", call: { kind: "pass" } },
      { seat: "S", call: { level: 3, strain: "N" } },
      { seat: "W", call: { kind: "pass" } },
      { seat: "N", call: { kind: "pass" } },
      { seat: "E", call: { kind: "pass" } },
    ],
    contract: { level: 3, strain: "N", declarer: "S", doubled: 0 },
    lead: { seat: "W", card: { suit: "S", rank: "3" } },
    intro: [],
    solution: "(Solution to be added.)",
  },
  {
    id: "ph7",
    title: "Declarer #7",
    deal: {
      hands: {
        N: [
          { suit: "S", rank: "J" },
          { suit: "S", rank: "T" },
          { suit: "S", rank: "9" },
          { suit: "S", rank: "3" },
          { suit: "H", rank: "2" },
          { suit: "D", rank: "A" },
          { suit: "D", rank: "8" },
          { suit: "D", rank: "6" },
          { suit: "D", rank: "3" },
          { suit: "C", rank: "A" },
          { suit: "C", rank: "8" },
          { suit: "C", rank: "3" },
          { suit: "C", rank: "2" },
        ],
        E: [
          { suit: "S", rank: "8" },
          { suit: "S", rank: "7" },
          { suit: "S", rank: "2" },
          { suit: "H", rank: "K" },
          { suit: "H", rank: "J" },
          { suit: "H", rank: "6" },
          { suit: "D", rank: "T" },
          { suit: "D", rank: "9" },
          { suit: "D", rank: "7" },
          { suit: "D", rank: "4" },
          { suit: "C", rank: "J" },
          { suit: "C", rank: "T" },
          { suit: "C", rank: "6" },
        ],
        S: [
          { suit: "S", rank: "A" },
          { suit: "S", rank: "K" },
          { suit: "S", rank: "Q" },
          { suit: "S", rank: "4" },
          { suit: "H", rank: "A" },
          { suit: "H", rank: "T" },
          { suit: "H", rank: "8" },
          { suit: "H", rank: "4" },
          { suit: "H", rank: "3" },
          { suit: "D", rank: "5" },
          { suit: "C", rank: "K" },
          { suit: "C", rank: "7" },
          { suit: "C", rank: "4" },
        ],
        W: [
          { suit: "S", rank: "6" },
          { suit: "S", rank: "5" },
          { suit: "H", rank: "Q" },
          { suit: "H", rank: "9" },
          { suit: "H", rank: "7" },
          { suit: "H", rank: "5" },
          { suit: "D", rank: "K" },
          { suit: "D", rank: "Q" },
          { suit: "D", rank: "J" },
          { suit: "D", rank: "2" },
          { suit: "C", rank: "Q" },
          { suit: "C", rank: "9" },
          { suit: "C", rank: "5" },
        ],
      },
      dealer: "S",
      vul: "",
    },
    // Auction left for Paul - the contract and the opening lead are his.
    auction: [],
    contract: { level: 4, strain: "S", declarer: "S", doubled: 0 },
    lead: { seat: "W", card: { suit: "D", rank: "K" } },
    intro: [],
    solution: "(Solution to be added.)",
  },

  // ---- From Dummy Play Secrets - Part 13 - Thinking about endplays ---------------------------
  // TODO(Paul): explanations to come. Paul (9 Sep 2026): each explanation must carry a LINK to
  // the article the hand came from. The link is stored in `source` and rendered by ProblemHandPlay.
  {
    id: "ph8",
    title: "Declarer #8",
    deal: {
      hands: {
        N: [
          { suit: "S", rank: "7" }, { suit: "S", rank: "4" }, { suit: "S", rank: "3" },
          { suit: "H", rank: "A" }, { suit: "H", rank: "J" }, { suit: "H", rank: "T" },
          { suit: "D", rank: "K" }, { suit: "D", rank: "9" }, { suit: "D", rank: "6" },
          { suit: "D", rank: "5" }, { suit: "D", rank: "4" },
          { suit: "C", rank: "T" }, { suit: "C", rank: "2" },
        ],
        E: [
          { suit: "S", rank: "A" }, { suit: "S", rank: "Q" }, { suit: "S", rank: "J" },
          { suit: "S", rank: "T" }, { suit: "S", rank: "6" }, { suit: "S", rank: "2" },
          { suit: "H", rank: "K" }, { suit: "H", rank: "7" }, { suit: "H", rank: "6" },
          { suit: "H", rank: "5" },
          { suit: "D", rank: "7" }, { suit: "D", rank: "2" },
          { suit: "C", rank: "5" },
        ],
        S: [
          { suit: "S", rank: "9" }, { suit: "S", rank: "8" }, { suit: "S", rank: "5" },
          { suit: "H", rank: "Q" },
          { suit: "D", rank: "A" }, { suit: "D", rank: "J" }, { suit: "D", rank: "3" },
          { suit: "C", rank: "A" }, { suit: "C", rank: "K" }, { suit: "C", rank: "Q" },
          { suit: "C", rank: "9" }, { suit: "C", rank: "8" }, { suit: "C", rank: "7" },
        ],
        W: [
          { suit: "S", rank: "K" },
          { suit: "H", rank: "9" }, { suit: "H", rank: "8" }, { suit: "H", rank: "4" },
          { suit: "H", rank: "3" }, { suit: "H", rank: "2" },
          { suit: "D", rank: "Q" }, { suit: "D", rank: "T" }, { suit: "D", rank: "8" },
          { suit: "C", rank: "J" }, { suit: "C", rank: "6" }, { suit: "C", rank: "4" },
          { suit: "C", rank: "3" },
        ],
      },
      dealer: "E",
      vul: "",
    },
    auction: [
      { seat: "E", call: { level: 2, strain: "S" } },
      { seat: "S", call: { level: 3, strain: "C" } },
      { seat: "W", call: { kind: "pass" } },
      { seat: "N", call: { kind: "pass" } },
      { seat: "E", call: { kind: "pass" } },
    ],
    contract: { level: 3, strain: "C", declarer: "S", doubled: 0 },
    lead: { seat: "W", card: { suit: "S", rank: "K" } },
    // Paul (9 Sep 2026): force the first three tricks and East's club at trick 4 - the ♠K is
    // overtaken with the Ace, top spades continued, West pitching HEARTS (left to itself the
    // bot pitched diamonds, which is not the article's position). The reader plays from
    // South's card at trick 4.
    forcedPlays: [
      { seat: "N", card: { suit: "S", rank: "3" } },
      { seat: "E", card: { suit: "S", rank: "A" } },
      { seat: "S", card: { suit: "S", rank: "5" } },
      { seat: "E", card: { suit: "S", rank: "Q" } },
      { seat: "S", card: { suit: "S", rank: "8" } },
      { seat: "W", card: { suit: "H", rank: "2" } },
      { seat: "N", card: { suit: "S", rank: "4" } },
      { seat: "E", card: { suit: "S", rank: "J" } },
      { seat: "S", card: { suit: "S", rank: "9" } },
      { seat: "W", card: { suit: "H", rank: "3" } },
      { seat: "N", card: { suit: "S", rank: "7" } },
      { seat: "E", card: { suit: "C", rank: "5" } },
    ],
    source: { title: "Dummy Play Secrets - Part 13 - Thinking about endplays", href: "/learn/defence/dummy-play-secrets-13" },
    intro: ["Explanation to come."],
    solution: "(Solution to be added.)",
  },
  {
    id: "ph9",
    title: "Declarer #9",
    deal: {
      hands: {
        N: [
          { suit: "S", rank: "K" }, { suit: "S", rank: "J" }, { suit: "S", rank: "5" },
          { suit: "S", rank: "2" },
          { suit: "H", rank: "5" }, { suit: "H", rank: "4" }, { suit: "H", rank: "2" },
          { suit: "D", rank: "K" }, { suit: "D", rank: "9" }, { suit: "D", rank: "4" },
          { suit: "C", rank: "K" }, { suit: "C", rank: "5" }, { suit: "C", rank: "2" },
        ],
        E: [
          { suit: "S", rank: "Q" }, { suit: "S", rank: "9" }, { suit: "S", rank: "6" },
          { suit: "H", rank: "A" }, { suit: "H", rank: "K" }, { suit: "H", rank: "8" },
          { suit: "H", rank: "6" },
          { suit: "D", rank: "Q" }, { suit: "D", rank: "T" }, { suit: "D", rank: "8" },
          { suit: "D", rank: "7" },
          { suit: "C", rank: "8" }, { suit: "C", rank: "7" },
        ],
        S: [
          { suit: "S", rank: "A" }, { suit: "S", rank: "T" }, { suit: "S", rank: "7" },
          { suit: "S", rank: "4" }, { suit: "S", rank: "3" },
          { suit: "H", rank: "Q" }, { suit: "H", rank: "J" }, { suit: "H", rank: "3" },
          { suit: "D", rank: "A" },
          { suit: "C", rank: "A" }, { suit: "C", rank: "J" }, { suit: "C", rank: "6" },
          { suit: "C", rank: "4" },
        ],
        W: [
          { suit: "S", rank: "8" },
          { suit: "H", rank: "T" }, { suit: "H", rank: "9" }, { suit: "H", rank: "7" },
          { suit: "D", rank: "J" }, { suit: "D", rank: "6" }, { suit: "D", rank: "5" },
          { suit: "D", rank: "3" }, { suit: "D", rank: "2" },
          { suit: "C", rank: "Q" }, { suit: "C", rank: "T" }, { suit: "C", rank: "9" },
          { suit: "C", rank: "3" },
        ],
      },
      dealer: "",
      vul: "",
    },
    auction: [],
    contract: { level: 4, strain: "S", declarer: "S", doubled: 0 },
    lead: { seat: "W", card: { suit: "H", rank: "T" } },
    source: { title: "Dummy Play Secrets - Part 13 - Thinking about endplays", href: "/learn/defence/dummy-play-secrets-13" },
    intro: ["Explanation to come."],
    solution: "(Solution to be added.)",
  },
  // ---- Board 25 from Dummy Play Secrets - Part 12 - Cash blocking cards ----------------------
  // World championship final, closed room (docs/article-payloads/wbs-final-board25-prep.md).
  // Rotated one seat so the human declares from South: the record's West -> S, North -> W,
  // East -> N, South -> E. Trick 1 is scripted from the record (♦4 lead, ♦2 from dummy, ♦Q
  // from RHO) so the reader takes over with the same choice the article poses.
  // TODO(Paul): explanation to come, with a link to the article (`source` below, already rendered).
  {
    id: "ph10",
    title: "Declarer #10",
    deal: {
      hands: {
        N: [
          { suit: "S", rank: "8" }, { suit: "S", rank: "2" },
          { suit: "H", rank: "A" }, { suit: "H", rank: "Q" }, { suit: "H", rank: "J" },
          { suit: "H", rank: "7" },
          { suit: "D", rank: "T" }, { suit: "D", rank: "9" }, { suit: "D", rank: "5" },
          { suit: "D", rank: "2" },
          { suit: "C", rank: "9" }, { suit: "C", rank: "8" }, { suit: "C", rank: "5" },
        ],
        E: [
          { suit: "S", rank: "7" }, { suit: "S", rank: "6" }, { suit: "S", rank: "4" },
          { suit: "S", rank: "3" },
          { suit: "H", rank: "K" }, { suit: "H", rank: "T" }, { suit: "H", rank: "9" },
          { suit: "H", rank: "8" },
          { suit: "D", rank: "Q" }, { suit: "D", rank: "8" }, { suit: "D", rank: "3" },
          { suit: "C", rank: "Q" }, { suit: "C", rank: "J" },
        ],
        S: [
          { suit: "S", rank: "A" }, { suit: "S", rank: "Q" }, { suit: "S", rank: "J" },
          { suit: "S", rank: "5" },
          { suit: "H", rank: "5" }, { suit: "H", rank: "4" }, { suit: "H", rank: "2" },
          { suit: "D", rank: "A" }, { suit: "D", rank: "J" },
          { suit: "C", rank: "A" }, { suit: "C", rank: "K" }, { suit: "C", rank: "7" },
          { suit: "C", rank: "6" },
        ],
        W: [
          { suit: "S", rank: "K" }, { suit: "S", rank: "T" }, { suit: "S", rank: "9" },
          { suit: "H", rank: "6" }, { suit: "H", rank: "3" },
          { suit: "D", rank: "K" }, { suit: "D", rank: "7" }, { suit: "D", rank: "6" },
          { suit: "D", rank: "4" },
          { suit: "C", rank: "T" }, { suit: "C", rank: "4" }, { suit: "C", rank: "3" },
          { suit: "C", rank: "2" },
        ],
      },
      dealer: "W",
      vul: "NS",
    },
    auction: [
      { seat: "W", call: { kind: "pass" } },
      { seat: "N", call: { kind: "pass" } },
      { seat: "E", call: { kind: "pass" } },
      { seat: "S", call: { level: 1, strain: "C" } },
      { seat: "W", call: { kind: "pass" } },
      { seat: "N", call: { level: 1, strain: "D" } },
      { seat: "E", call: { kind: "pass" } },
      { seat: "S", call: { level: 2, strain: "N" } },
      { seat: "W", call: { kind: "pass" } },
      { seat: "N", call: { level: 3, strain: "N" } },
      { seat: "E", call: { kind: "pass" } },
      { seat: "S", call: { kind: "pass" } },
      { seat: "W", call: { kind: "pass" } },
    ],
    contract: { level: 3, strain: "N", declarer: "S", doubled: 0 },
    lead: { seat: "W", card: { suit: "D", rank: "4" } },
    forcedPlays: [
      { seat: "N", card: { suit: "D", rank: "2" } },
      { seat: "E", card: { suit: "D", rank: "Q" } },
    ],
    source: { title: "Dummy Play Secrets - Part 12 - Cash blocking cards", href: "/learn/defence/dummy-play-secrets-12" },
    intro: ["Explanation to come."],
    solution: "(Solution to be added.)",
  },
  // Take All Your Chances (Kantar), solution 19. Both vul, 3♣ by South. West cashes ♦K, ♦A and leads a third diamond to East's queen - those three tricks are scripted, then the reader takes over.
  // TODO(Paul): explanation and solution to come.
  {
    id: "ph11",
    title: "Declarer #11",
    deal: {
      hands: {
        N: [{ suit: "S", rank: "7" }, { suit: "S", rank: "5" }, { suit: "S", rank: "4" }, { suit: "S", rank: "3" }, { suit: "H", rank: "6" }, { suit: "H", rank: "5" }, { suit: "H", rank: "4" }, { suit: "D", rank: "7" }, { suit: "D", rank: "6" }, { suit: "D", rank: "5" }, { suit: "C", rank: "T" }, { suit: "C", rank: "9" }, { suit: "C", rank: "7" }],
        E: [{ suit: "S", rank: "A" }, { suit: "S", rank: "9" }, { suit: "S", rank: "6" }, { suit: "H", rank: "J" }, { suit: "H", rank: "T" }, { suit: "H", rank: "8" }, { suit: "H", rank: "7" }, { suit: "H", rank: "3" }, { suit: "D", rank: "Q" }, { suit: "D", rank: "9" }, { suit: "D", rank: "8" }, { suit: "C", rank: "8" }, { suit: "C", rank: "2" }],
        S: [{ suit: "S", rank: "K" }, { suit: "S", rank: "Q" }, { suit: "H", rank: "A" }, { suit: "H", rank: "Q" }, { suit: "H", rank: "2" }, { suit: "D", rank: "T" }, { suit: "D", rank: "4" }, { suit: "C", rank: "A" }, { suit: "C", rank: "K" }, { suit: "C", rank: "Q" }, { suit: "C", rank: "J" }, { suit: "C", rank: "5" }, { suit: "C", rank: "3" }],
        W: [{ suit: "S", rank: "J" }, { suit: "S", rank: "T" }, { suit: "S", rank: "8" }, { suit: "S", rank: "2" }, { suit: "H", rank: "K" }, { suit: "H", rank: "9" }, { suit: "D", rank: "A" }, { suit: "D", rank: "K" }, { suit: "D", rank: "J" }, { suit: "D", rank: "3" }, { suit: "D", rank: "2" }, { suit: "C", rank: "6" }, { suit: "C", rank: "4" }],
      },
      dealer: "W",
      vul: "Both",
    },
    auction: [
      { seat: "W", call: { level: 1, strain: "D" } },
      { seat: "N", call: { kind: "pass" } },
      { seat: "E", call: { level: 1, strain: "H" } },
      { seat: "S", call: { kind: "double" } },
      { seat: "W", call: { kind: "pass" } },
      { seat: "N", call: { level: 1, strain: "S" } },
      { seat: "E", call: { level: 2, strain: "D" } },
      { seat: "S", call: { level: 3, strain: "C" } },
      { seat: "W", call: { kind: "pass" } },
      { seat: "N", call: { kind: "pass" } },
      { seat: "E", call: { kind: "pass" } },
    ],
    contract: { level: 3, strain: "C", declarer: "S", doubled: 0 },
    lead: { seat: "W", card: { suit: "D", rank: "K" } },
    forcedPlays: [
      { seat: "N", card: { suit: "D", rank: "5" } },
      { seat: "E", card: { suit: "D", rank: "8" } },
      { seat: "S", card: { suit: "D", rank: "4" } },
      { seat: "W", card: { suit: "D", rank: "A" } },
      { seat: "N", card: { suit: "D", rank: "6" } },
      { seat: "E", card: { suit: "D", rank: "9" } },
      { seat: "S", card: { suit: "D", rank: "T" } },
      { seat: "W", card: { suit: "D", rank: "2" } },
      { seat: "N", card: { suit: "D", rank: "7" } },
      { seat: "E", card: { suit: "D", rank: "Q" } },
    ],
    intro: ["Explanation to come."],
    solution: "(Solution to be added.)",
  },
  // Take All Your Chances (Kantar), solution 23. 6♥ by South after a 2♣ opening (auction not given in the book, so it is synthesised from the contract). West leads ♣Q.
  // TODO(Paul): explanation and solution to come.
  {
    id: "ph12",
    title: "Declarer #12",
    deal: {
      hands: {
        N: [{ suit: "S", rank: "Q" }, { suit: "S", rank: "8" }, { suit: "S", rank: "6" }, { suit: "S", rank: "2" }, { suit: "H", rank: "7" }, { suit: "H", rank: "6" }, { suit: "D", rank: "A" }, { suit: "D", rank: "K" }, { suit: "D", rank: "4" }, { suit: "D", rank: "2" }, { suit: "C", rank: "5" }, { suit: "C", rank: "4" }, { suit: "C", rank: "3" }],
        E: [{ suit: "S", rank: "K" }, { suit: "S", rank: "T" }, { suit: "S", rank: "9" }, { suit: "S", rank: "7" }, { suit: "H", rank: "4" }, { suit: "D", rank: "Q" }, { suit: "D", rank: "T" }, { suit: "D", rank: "8" }, { suit: "D", rank: "5" }, { suit: "D", rank: "3" }, { suit: "C", rank: "8" }, { suit: "C", rank: "7" }, { suit: "C", rank: "6" }],
        S: [{ suit: "S", rank: "A" }, { suit: "S", rank: "4" }, { suit: "S", rank: "3" }, { suit: "H", rank: "A" }, { suit: "H", rank: "K" }, { suit: "H", rank: "Q" }, { suit: "H", rank: "J" }, { suit: "H", rank: "T" }, { suit: "H", rank: "9" }, { suit: "H", rank: "5" }, { suit: "H", rank: "2" }, { suit: "C", rank: "A" }, { suit: "C", rank: "K" }],
        W: [{ suit: "S", rank: "J" }, { suit: "S", rank: "5" }, { suit: "H", rank: "8" }, { suit: "H", rank: "3" }, { suit: "D", rank: "J" }, { suit: "D", rank: "9" }, { suit: "D", rank: "7" }, { suit: "D", rank: "6" }, { suit: "C", rank: "Q" }, { suit: "C", rank: "J" }, { suit: "C", rank: "T" }, { suit: "C", rank: "9" }, { suit: "C", rank: "2" }],
      },
      dealer: "S",
      vul: "",
    },
    auction: [],
    contract: { level: 6, strain: "H", declarer: "S", doubled: 0 },
    lead: { seat: "W", card: { suit: "C", rank: "Q" } },
    intro: ["Explanation to come."],
    solution: "(Solution to be added.)",
  },
  // Take All Your Chances (Kantar), solution 24. 1♦ - 1♥ - 1♠ then 6♥ by South. West leads ♣J; dummy's ♣Q and East's ♣K are scripted, then the reader takes over. Book's bonus question: same deal in 7♥.
  // TODO(Paul): explanation and solution to come.
  {
    id: "ph13",
    title: "Declarer #13",
    deal: {
      hands: {
        N: [{ suit: "S", rank: "A" }, { suit: "S", rank: "J" }, { suit: "S", rank: "T" }, { suit: "S", rank: "3" }, { suit: "H", rank: "6" }, { suit: "H", rank: "4" }, { suit: "D", rank: "A" }, { suit: "D", rank: "J" }, { suit: "D", rank: "T" }, { suit: "D", rank: "9" }, { suit: "D", rank: "2" }, { suit: "C", rank: "Q" }, { suit: "C", rank: "3" }],
        E: [{ suit: "S", rank: "K" }, { suit: "S", rank: "2" }, { suit: "H", rank: "8" }, { suit: "H", rank: "3" }, { suit: "D", rank: "Q" }, { suit: "D", rank: "7" }, { suit: "D", rank: "6" }, { suit: "D", rank: "5" }, { suit: "C", rank: "K" }, { suit: "C", rank: "9" }, { suit: "C", rank: "5" }, { suit: "C", rank: "4" }, { suit: "C", rank: "2" }],
        S: [{ suit: "S", rank: "Q" }, { suit: "S", rank: "9" }, { suit: "S", rank: "4" }, { suit: "H", rank: "A" }, { suit: "H", rank: "K" }, { suit: "H", rank: "Q" }, { suit: "H", rank: "J" }, { suit: "H", rank: "T" }, { suit: "H", rank: "2" }, { suit: "D", rank: "K" }, { suit: "D", rank: "3" }, { suit: "C", rank: "A" }, { suit: "C", rank: "6" }],
        W: [{ suit: "S", rank: "8" }, { suit: "S", rank: "7" }, { suit: "S", rank: "6" }, { suit: "S", rank: "5" }, { suit: "H", rank: "9" }, { suit: "H", rank: "7" }, { suit: "H", rank: "5" }, { suit: "D", rank: "8" }, { suit: "D", rank: "4" }, { suit: "C", rank: "J" }, { suit: "C", rank: "T" }, { suit: "C", rank: "8" }, { suit: "C", rank: "7" }],
      },
      dealer: "N",
      vul: "",
    },
    auction: [
      { seat: "N", call: { level: 1, strain: "D" } },
      { seat: "E", call: { kind: "pass" } },
      { seat: "S", call: { level: 1, strain: "H" } },
      { seat: "W", call: { kind: "pass" } },
      { seat: "N", call: { level: 1, strain: "S" } },
      { seat: "E", call: { kind: "pass" } },
      { seat: "S", call: { level: 6, strain: "H" } },
      { seat: "W", call: { kind: "pass" } },
      { seat: "N", call: { kind: "pass" } },
      { seat: "E", call: { kind: "pass" } },
    ],
    contract: { level: 6, strain: "H", declarer: "S", doubled: 0 },
    lead: { seat: "W", card: { suit: "C", rank: "J" } },
    forcedPlays: [
      { seat: "N", card: { suit: "C", rank: "Q" } },
      { seat: "E", card: { suit: "C", rank: "K" } },
    ],
    intro: ["Explanation to come."],
    solution: "(Solution to be added.)",
  },
  // Take All Your Chances (Kantar), solution 25 (advanced). 1♦ - 1NT by South, IMPs. West leads ♣2. Book's second question: same deal in 3NT.
  // TODO(Paul): explanation and solution to come.
  {
    id: "ph14",
    title: "Declarer #14",
    deal: {
      hands: {
        N: [{ suit: "S", rank: "A" }, { suit: "S", rank: "K" }, { suit: "S", rank: "2" }, { suit: "H", rank: "J" }, { suit: "H", rank: "T" }, { suit: "H", rank: "9" }, { suit: "D", rank: "Q" }, { suit: "D", rank: "T" }, { suit: "D", rank: "8" }, { suit: "D", rank: "7" }, { suit: "D", rank: "2" }, { suit: "C", rank: "A" }, { suit: "C", rank: "5" }],
        E: [{ suit: "S", rank: "J" }, { suit: "S", rank: "9" }, { suit: "S", rank: "7" }, { suit: "H", rank: "A" }, { suit: "H", rank: "Q" }, { suit: "H", rank: "7" }, { suit: "D", rank: "K" }, { suit: "D", rank: "J" }, { suit: "D", rank: "4" }, { suit: "C", rank: "J" }, { suit: "C", rank: "7" }, { suit: "C", rank: "4" }, { suit: "C", rank: "3" }],
        S: [{ suit: "S", rank: "Q" }, { suit: "S", rank: "T" }, { suit: "S", rank: "4" }, { suit: "H", rank: "8" }, { suit: "H", rank: "6" }, { suit: "H", rank: "3" }, { suit: "H", rank: "2" }, { suit: "D", rank: "A" }, { suit: "D", rank: "9" }, { suit: "D", rank: "5" }, { suit: "C", rank: "K" }, { suit: "C", rank: "9" }, { suit: "C", rank: "6" }],
        W: [{ suit: "S", rank: "8" }, { suit: "S", rank: "6" }, { suit: "S", rank: "5" }, { suit: "S", rank: "3" }, { suit: "H", rank: "K" }, { suit: "H", rank: "5" }, { suit: "H", rank: "4" }, { suit: "D", rank: "6" }, { suit: "D", rank: "3" }, { suit: "C", rank: "Q" }, { suit: "C", rank: "T" }, { suit: "C", rank: "8" }, { suit: "C", rank: "2" }],
      },
      dealer: "N",
      vul: "",
    },
    auction: [
      { seat: "N", call: { level: 1, strain: "D" } },
      { seat: "E", call: { kind: "pass" } },
      { seat: "S", call: { level: 1, strain: "N" } },
      { seat: "W", call: { kind: "pass" } },
      { seat: "N", call: { kind: "pass" } },
      { seat: "E", call: { kind: "pass" } },
    ],
    contract: { level: 1, strain: "N", declarer: "S", doubled: 0 },
    lead: { seat: "W", card: { suit: "C", rank: "2" } },
    intro: ["Explanation to come."],
    solution: "(Solution to be added.)",
  },
  // Take All Your Chances (Kantar), solution 17. 1♦ - 1♠ - 1NT - 3♠ (forcing) - 3NT - 6♠ by South.
  // West leads ♥10; nothing scripted, the trick-one card from dummy is the reader's choice.
  // TODO(Paul): explanation and solution to come.
  {
    id: "ph15",
    title: "Declarer #15",
    deal: {
      hands: {
        N: [{ suit: "S", rank: "9" }, { suit: "S", rank: "2" }, { suit: "H", rank: "Q" }, { suit: "H", rank: "J" }, { suit: "H", rank: "5" }, { suit: "D", rank: "A" }, { suit: "D", rank: "K" }, { suit: "D", rank: "Q" }, { suit: "D", rank: "6" }, { suit: "C", rank: "J" }, { suit: "C", rank: "9" }, { suit: "C", rank: "4" }, { suit: "C", rank: "3" }],
        E: [{ suit: "S", rank: "6" }, { suit: "S", rank: "5" }, { suit: "S", rank: "4" }, { suit: "H", rank: "K" }, { suit: "H", rank: "7" }, { suit: "H", rank: "4" }, { suit: "H", rank: "3" }, { suit: "D", rank: "T" }, { suit: "D", rank: "8" }, { suit: "D", rank: "7" }, { suit: "D", rank: "2" }, { suit: "C", rank: "6" }, { suit: "C", rank: "5" }],
        S: [{ suit: "S", rank: "A" }, { suit: "S", rank: "K" }, { suit: "S", rank: "Q" }, { suit: "S", rank: "J" }, { suit: "S", rank: "T" }, { suit: "H", rank: "A" }, { suit: "H", rank: "6" }, { suit: "H", rank: "2" }, { suit: "D", rank: "J" }, { suit: "C", rank: "A" }, { suit: "C", rank: "T" }, { suit: "C", rank: "8" }, { suit: "C", rank: "7" }],
        W: [{ suit: "S", rank: "8" }, { suit: "S", rank: "7" }, { suit: "S", rank: "3" }, { suit: "H", rank: "T" }, { suit: "H", rank: "9" }, { suit: "H", rank: "8" }, { suit: "D", rank: "9" }, { suit: "D", rank: "5" }, { suit: "D", rank: "4" }, { suit: "D", rank: "3" }, { suit: "C", rank: "K" }, { suit: "C", rank: "Q" }, { suit: "C", rank: "2" }],
      },
      dealer: "N",
      vul: "",
    },
    auction: [
      { seat: "N", call: { level: 1, strain: "D" } },
      { seat: "E", call: { kind: "pass" } },
      { seat: "S", call: { level: 1, strain: "S" } },
      { seat: "W", call: { kind: "pass" } },
      { seat: "N", call: { level: 1, strain: "N" } },
      { seat: "E", call: { kind: "pass" } },
      { seat: "S", call: { level: 3, strain: "S" } },
      { seat: "W", call: { kind: "pass" } },
      { seat: "N", call: { level: 3, strain: "N" } },
      { seat: "E", call: { kind: "pass" } },
      { seat: "S", call: { level: 6, strain: "S" } },
      { seat: "W", call: { kind: "pass" } },
      { seat: "N", call: { kind: "pass" } },
      { seat: "E", call: { kind: "pass" } },
    ],
    contract: { level: 6, strain: "S", declarer: "S", doubled: 0 },
    lead: { seat: "W", card: { suit: "H", rank: "T" } },
    // Paul (1 Oct 2026, Game Plan hand 6): "Make easy - play low heart trick 1 ... East". East does not
    // cover at trick 1 on West's heart lead; after that the bot plays normally.
    playRules: [{ seat: "E", ledBy: "W", suit: "H", play: "low", once: true }],
    intro: ["Explanation to come."],
    solution: "(Solution to be added.)",
  },
  // Paul, 25 Sep 2026 (problem hands 16-20; 18 added after Paul settled its ♣K clash).
  // Spot cards for Paul's x's filled in by Claude; every deal checked for 52 unique cards.
  // Hand 16: Paul gave North ♦AQx AND West ♦Qxx. North's (dummy's) holding kept; West's ♦Q made a low
  // card - N/S hold ♦AKQ either way. Flagged to Paul. East wins ♣A, cashes ♣K, leads ♣Q - scripted.
  // TODO(Paul): solution. Paul's note for the solution: "loser on loser".
  {
    id: "ph16",
    title: "Declarer #16",
    deal: {
      hands: {
        N: [{ suit: "S", rank: "J" }, { suit: "S", rank: "5" }, { suit: "S", rank: "3" }, { suit: "H", rank: "K" }, { suit: "H", rank: "4" }, { suit: "H", rank: "3" }, { suit: "H", rank: "2" }, { suit: "D", rank: "A" }, { suit: "D", rank: "Q" }, { suit: "D", rank: "2" }, { suit: "C", rank: "6" }, { suit: "C", rank: "5" }, { suit: "C", rank: "4" }],
        E: [{ suit: "S", rank: "2" }, { suit: "H", rank: "J" }, { suit: "H", rank: "5" }, { suit: "D", rank: "J" }, { suit: "D", rank: "T" }, { suit: "D", rank: "9" }, { suit: "D", rank: "5" }, { suit: "C", rank: "A" }, { suit: "C", rank: "K" }, { suit: "C", rank: "Q" }, { suit: "C", rank: "T" }, { suit: "C", rank: "9" }, { suit: "C", rank: "8" }],
        S: [{ suit: "S", rank: "A" }, { suit: "S", rank: "K" }, { suit: "S", rank: "Q" }, { suit: "S", rank: "6" }, { suit: "S", rank: "4" }, { suit: "H", rank: "A" }, { suit: "H", rank: "7" }, { suit: "H", rank: "6" }, { suit: "D", rank: "K" }, { suit: "D", rank: "6" }, { suit: "D", rank: "3" }, { suit: "C", rank: "7" }, { suit: "C", rank: "3" }],
        W: [{ suit: "S", rank: "T" }, { suit: "S", rank: "9" }, { suit: "S", rank: "8" }, { suit: "S", rank: "7" }, { suit: "H", rank: "Q" }, { suit: "H", rank: "T" }, { suit: "H", rank: "9" }, { suit: "H", rank: "8" }, { suit: "D", rank: "8" }, { suit: "D", rank: "7" }, { suit: "D", rank: "4" }, { suit: "C", rank: "J" }, { suit: "C", rank: "2" }],
      },
      dealer: "S",
      vul: "",
    },
    auction: [
      { seat: "S", call: {level: 1, strain: "N"} },
      { seat: "W", call: {kind: "pass"} },
      { seat: "N", call: {level: 3, strain: "C"}, alert: true, explanation: "Puppet Stayman" },
      { seat: "E", call: {kind: "pass"} },
      { seat: "S", call: {level: 3, strain: "S"}, alert: true, explanation: "Shows a 5 card spade suit" },
      { seat: "W", call: {kind: "pass"} },
      { seat: "N", call: {level: 4, strain: "S"} },
      { seat: "E", call: {kind: "pass"} },
      { seat: "S", call: {kind: "pass"} },
      { seat: "W", call: {kind: "pass"} },
    ],
    auctionNote: "*3♣ was Puppet Stayman, 3♠ showed a 5 card spade suit.",
    contract: { level: 4, strain: "S", declarer: "S", doubled: 0 },
    lead: { seat: "W", card: { suit: "C", rank: "J" } },
    forcedPlays: [
      { seat: "N", card: { suit: "C", rank: "4" } },
      { seat: "E", card: { suit: "C", rank: "A" } },
      { seat: "S", card: { suit: "C", rank: "3" } },
      { seat: "E", card: { suit: "C", rank: "K" } },
      { seat: "S", card: { suit: "C", rank: "7" } },
      { seat: "W", card: { suit: "C", rank: "2" } },
      { seat: "N", card: { suit: "C", rank: "5" } },
      { seat: "E", card: { suit: "C", rank: "Q" } },
    ],
    intro: ["The contract is good this time, but it is advisable to just bid 3NT when you are strong enough for game and are 4-3-3-3 opposite a 1NT opening."],
    solution: "(Solution to be added.)",
  },
  // Paul, 25 Sep 2026. No auction given (synthesised from the contract). West leads the ♣2.
  // TODO(Paul): explanation and solution. Paul's note for the solution: "just draw".
  {
    id: "ph17",
    title: "Declarer #17",
    deal: {
      hands: {
        N: [{ suit: "S", rank: "A" }, { suit: "S", rank: "3" }, { suit: "S", rank: "2" }, { suit: "H", rank: "6" }, { suit: "H", rank: "2" }, { suit: "D", rank: "T" }, { suit: "D", rank: "3" }, { suit: "D", rank: "2" }, { suit: "C", rank: "A" }, { suit: "C", rank: "Q" }, { suit: "C", rank: "7" }, { suit: "C", rank: "6" }, { suit: "C", rank: "4" }],
        E: [{ suit: "S", rank: "Q" }, { suit: "S", rank: "J" }, { suit: "S", rank: "T" }, { suit: "S", rank: "9" }, { suit: "H", rank: "Q" }, { suit: "H", rank: "J" }, { suit: "H", rank: "T" }, { suit: "H", rank: "9" }, { suit: "D", rank: "9" }, { suit: "D", rank: "8" }, { suit: "D", rank: "7" }, { suit: "C", rank: "9" }, { suit: "C", rank: "8" }],
        S: [{ suit: "S", rank: "5" }, { suit: "S", rank: "4" }, { suit: "H", rank: "A" }, { suit: "H", rank: "4" }, { suit: "H", rank: "3" }, { suit: "D", rank: "K" }, { suit: "D", rank: "Q" }, { suit: "D", rank: "J" }, { suit: "D", rank: "5" }, { suit: "D", rank: "4" }, { suit: "C", rank: "K" }, { suit: "C", rank: "J" }, { suit: "C", rank: "3" }],
        W: [{ suit: "S", rank: "K" }, { suit: "S", rank: "8" }, { suit: "S", rank: "7" }, { suit: "S", rank: "6" }, { suit: "H", rank: "K" }, { suit: "H", rank: "8" }, { suit: "H", rank: "7" }, { suit: "H", rank: "5" }, { suit: "D", rank: "A" }, { suit: "D", rank: "6" }, { suit: "C", rank: "T" }, { suit: "C", rank: "5" }, { suit: "C", rank: "2" }],
      },
      dealer: "S",
      vul: "",
    },
    auction: [],
    contract: { level: 5, strain: "D", declarer: "S", doubled: 0 },
    lead: { seat: "W", card: { suit: "C", rank: "2" } },
    intro: ["Explanation to come."],
    solution: "(Solution to be added.)",
  },
  // Paul, 25 Sep 2026: "south should be Kx, get rid of east's king" - East's ♣KJxxxx became ♣Jxxxxx,
  // which leaves the ♣Q with West. No auction given (synthesised). West leads a diamond (♦3, from ♦32).
  // TODO(Paul): explanation and solution.
  {
    id: "ph18",
    title: "Declarer #18",
    deal: {
      hands: {
        N: [{ suit: "S", rank: "A" }, { suit: "S", rank: "K" }, { suit: "S", rank: "J" }, { suit: "S", rank: "2" }, { suit: "H", rank: "A" }, { suit: "H", rank: "3" }, { suit: "H", rank: "2" }, { suit: "D", rank: "K" }, { suit: "D", rank: "9" }, { suit: "D", rank: "8" }, { suit: "C", rank: "A" }, { suit: "C", rank: "3" }, { suit: "C", rank: "2" }],
        E: [{ suit: "S", rank: "Q" }, { suit: "S", rank: "5" }, { suit: "S", rank: "4" }, { suit: "H", rank: "K" }, { suit: "H", rank: "5" }, { suit: "H", rank: "4" }, { suit: "D", rank: "T" }, { suit: "C", rank: "J" }, { suit: "C", rank: "T" }, { suit: "C", rank: "9" }, { suit: "C", rank: "8" }, { suit: "C", rank: "7" }, { suit: "C", rank: "6" }],
        S: [{ suit: "S", rank: "3" }, { suit: "H", rank: "Q" }, { suit: "H", rank: "J" }, { suit: "H", rank: "T" }, { suit: "D", rank: "A" }, { suit: "D", rank: "Q" }, { suit: "D", rank: "J" }, { suit: "D", rank: "7" }, { suit: "D", rank: "6" }, { suit: "D", rank: "5" }, { suit: "D", rank: "4" }, { suit: "C", rank: "K" }, { suit: "C", rank: "4" }],
        W: [{ suit: "S", rank: "T" }, { suit: "S", rank: "9" }, { suit: "S", rank: "8" }, { suit: "S", rank: "7" }, { suit: "S", rank: "6" }, { suit: "H", rank: "9" }, { suit: "H", rank: "8" }, { suit: "H", rank: "7" }, { suit: "H", rank: "6" }, { suit: "D", rank: "3" }, { suit: "D", rank: "2" }, { suit: "C", rank: "Q" }, { suit: "C", rank: "5" }],
      },
      dealer: "S",
      vul: "",
    },
    auction: [],
    contract: { level: 7, strain: "D", declarer: "S", doubled: 0 },
    lead: { seat: "W", card: { suit: "D", rank: "3" } },
    intro: ["Explanation to come."],
    solution: "(Solution to be added.)",
  },
  // Paul, 25 Sep 2026. No auction given. West leads the ♣Q. TODO(Paul): explanation and solution.
  {
    id: "ph19",
    title: "Declarer #19",
    deal: {
      hands: {
        N: [{ suit: "S", rank: "A" }, { suit: "S", rank: "K" }, { suit: "S", rank: "J" }, { suit: "H", rank: "4" }, { suit: "H", rank: "3" }, { suit: "D", rank: "A" }, { suit: "D", rank: "7" }, { suit: "D", rank: "5" }, { suit: "D", rank: "2" }, { suit: "C", rank: "A" }, { suit: "C", rank: "9" }, { suit: "C", rank: "7" }, { suit: "C", rank: "5" }],
        E: [{ suit: "S", rank: "Q" }, { suit: "S", rank: "5" }, { suit: "S", rank: "4" }, { suit: "S", rank: "3" }, { suit: "H", rank: "Q" }, { suit: "H", rank: "J" }, { suit: "H", rank: "T" }, { suit: "H", rank: "9" }, { suit: "D", rank: "Q" }, { suit: "D", rank: "J" }, { suit: "D", rank: "T" }, { suit: "D", rank: "8" }, { suit: "C", rank: "K" }],
        S: [{ suit: "S", rank: "T" }, { suit: "S", rank: "9" }, { suit: "S", rank: "8" }, { suit: "S", rank: "7" }, { suit: "S", rank: "6" }, { suit: "H", rank: "A" }, { suit: "H", rank: "7" }, { suit: "H", rank: "6" }, { suit: "H", rank: "5" }, { suit: "D", rank: "K" }, { suit: "D", rank: "4" }, { suit: "D", rank: "3" }, { suit: "C", rank: "2" }],
        W: [{ suit: "S", rank: "2" }, { suit: "H", rank: "K" }, { suit: "H", rank: "8" }, { suit: "H", rank: "2" }, { suit: "D", rank: "9" }, { suit: "D", rank: "6" }, { suit: "C", rank: "Q" }, { suit: "C", rank: "J" }, { suit: "C", rank: "T" }, { suit: "C", rank: "8" }, { suit: "C", rank: "6" }, { suit: "C", rank: "4" }, { suit: "C", rank: "3" }],
      },
      dealer: "S",
      vul: "",
    },
    auction: [],
    contract: { level: 4, strain: "S", declarer: "S", doubled: 0 },
    lead: { seat: "W", card: { suit: "C", rank: "Q" } },
    intro: ["Explanation to come."],
    solution: "(Solution to be added.)",
  },
  // Paul, 25 Sep 2026. No auction given. West leads the ♣K. TODO(Paul): explanation and solution.
  {
    id: "ph20",
    title: "Declarer #20",
    deal: {
      hands: {
        N: [{ suit: "S", rank: "K" }, { suit: "S", rank: "J" }, { suit: "S", rank: "9" }, { suit: "S", rank: "2" }, { suit: "H", rank: "Q" }, { suit: "H", rank: "4" }, { suit: "H", rank: "3" }, { suit: "D", rank: "K" }, { suit: "D", rank: "J" }, { suit: "D", rank: "T" }, { suit: "C", rank: "A" }, { suit: "C", rank: "5" }, { suit: "C", rank: "4" }],
        E: [{ suit: "S", rank: "Q" }, { suit: "S", rank: "7" }, { suit: "S", rank: "5" }, { suit: "H", rank: "K" }, { suit: "H", rank: "T" }, { suit: "H", rank: "9" }, { suit: "D", rank: "Q" }, { suit: "D", rank: "9" }, { suit: "D", rank: "8" }, { suit: "D", rank: "4" }, { suit: "C", rank: "J" }, { suit: "C", rank: "T" }, { suit: "C", rank: "9" }],
        S: [{ suit: "S", rank: "A" }, { suit: "S", rank: "T" }, { suit: "S", rank: "8" }, { suit: "S", rank: "3" }, { suit: "H", rank: "J" }, { suit: "H", rank: "5" }, { suit: "H", rank: "2" }, { suit: "D", rank: "A" }, { suit: "D", rank: "3" }, { suit: "D", rank: "2" }, { suit: "C", rank: "8" }, { suit: "C", rank: "6" }, { suit: "C", rank: "2" }],
        W: [{ suit: "S", rank: "6" }, { suit: "S", rank: "4" }, { suit: "H", rank: "A" }, { suit: "H", rank: "8" }, { suit: "H", rank: "7" }, { suit: "H", rank: "6" }, { suit: "D", rank: "7" }, { suit: "D", rank: "6" }, { suit: "D", rank: "5" }, { suit: "C", rank: "K" }, { suit: "C", rank: "Q" }, { suit: "C", rank: "7" }, { suit: "C", rank: "3" }],
      },
      dealer: "S",
      vul: "",
    },
    auction: [],
    contract: { level: 2, strain: "S", declarer: "S", doubled: 0 },
    lead: { seat: "W", card: { suit: "C", rank: "K" } },
    intro: ["Explanation to come."],
    solution: "(Solution to be added.)",
  },
  // Paul, 3 Nov 2026 (two problem hands from the 2026 Spring Nationals Open Teams, abfevents.com.au).
  // DRAFT - Paul to approve before this is pushed. "problem hands are just play" - intro/solution to come.
  // Semi-final set 1 board 9: 2NT by North, ♠5 lead (Paul, 3 Nov 2026: "its 2NT not 3NT"). Rotated 180° so the declarer sits South (N<->S, E<->W);
  // dealer N -> S, vul E-W unchanged. No auction given.
  // https://www.abfevents.com.au/events/results/results.asp?yr=2026&dir=sn/sn5&E=8&R=1&B=9&T=O
  {
    id: "ph21",
    title: "Declarer #21",
    deal: {
      hands: {
        N: [{ suit: "S", rank: "9" }, { suit: "H", rank: "A" }, { suit: "H", rank: "9" }, { suit: "H", rank: "8" }, { suit: "H", rank: "7" }, { suit: "H", rank: "6" }, { suit: "D", rank: "A" }, { suit: "D", rank: "K" }, { suit: "D", rank: "J" }, { suit: "D", rank: "7" }, { suit: "C", rank: "T" }, { suit: "C", rank: "6" }, { suit: "C", rank: "2" }],
        E: [{ suit: "S", rank: "T" }, { suit: "S", rank: "7" }, { suit: "S", rank: "4" }, { suit: "S", rank: "2" }, { suit: "H", rank: "K" }, { suit: "H", rank: "J" }, { suit: "H", rank: "5" }, { suit: "D", rank: "6" }, { suit: "D", rank: "3" }, { suit: "D", rank: "2" }, { suit: "C", rank: "K" }, { suit: "C", rank: "9" }, { suit: "C", rank: "8" }],
        S: [{ suit: "S", rank: "A" }, { suit: "S", rank: "Q" }, { suit: "S", rank: "J" }, { suit: "H", rank: "T" }, { suit: "H", rank: "4" }, { suit: "H", rank: "2" }, { suit: "D", rank: "9" }, { suit: "D", rank: "8" }, { suit: "D", rank: "5" }, { suit: "D", rank: "4" }, { suit: "C", rank: "Q" }, { suit: "C", rank: "J" }, { suit: "C", rank: "4" }],
        W: [{ suit: "S", rank: "K" }, { suit: "S", rank: "8" }, { suit: "S", rank: "6" }, { suit: "S", rank: "5" }, { suit: "S", rank: "3" }, { suit: "H", rank: "Q" }, { suit: "H", rank: "3" }, { suit: "D", rank: "Q" }, { suit: "D", rank: "T" }, { suit: "C", rank: "A" }, { suit: "C", rank: "7" }, { suit: "C", rank: "5" }, { suit: "C", rank: "3" }],
      },
      dealer: "S",
      vul: "EW",
    },
    auction: [],
    contract: { level: 2, strain: "N", declarer: "S", doubled: 0 },
    lead: { seat: "W", card: { suit: "S", rank: "5" } },
    intro: ["Explanation to come."],
    solution: "(Solution to be added.)",
  },
  // Final set 4 board 27: 6♣ by West, ♠K lead, auction 1♥ 2♣ 2♥ 4NT P 5♥ P 6♣. Paul: "change the hand slightly so
  // that south has 1 more diamond. Give north a spade in return" - table South's ♠5 swapped for table North's ♦2
  // (diamonds now 4-2). Rotated so the declarer sits South (W->S, N->W, E->N, S->E); dealer S -> E, vul none.
  // https://www.abfevents.com.au/events/results/results.asp?yr=2026&dir=sn/sn5&E=9&R=4&B=27&T=O
  {
    id: "ph22",
    title: "Declarer #22",
    deal: {
      hands: {
        N: [{ suit: "S", rank: "7" }, { suit: "S", rank: "6" }, { suit: "S", rank: "4" }, { suit: "H", rank: "7" }, { suit: "D", rank: "A" }, { suit: "D", rank: "K" }, { suit: "D", rank: "T" }, { suit: "D", rank: "6" }, { suit: "D", rank: "5" }, { suit: "D", rank: "3" }, { suit: "C", rank: "A" }, { suit: "C", rank: "J" }, { suit: "C", rank: "3" }],
        E: [{ suit: "S", rank: "J" }, { suit: "H", rank: "A" }, { suit: "H", rank: "K" }, { suit: "H", rank: "Q" }, { suit: "H", rank: "9" }, { suit: "H", rank: "8" }, { suit: "H", rank: "4" }, { suit: "D", rank: "Q" }, { suit: "D", rank: "J" }, { suit: "D", rank: "4" }, { suit: "D", rank: "2" }, { suit: "C", rank: "7" }, { suit: "C", rank: "4" }],
        S: [{ suit: "S", rank: "A" }, { suit: "S", rank: "9" }, { suit: "S", rank: "3" }, { suit: "S", rank: "2" }, { suit: "H", rank: "J" }, { suit: "H", rank: "3" }, { suit: "D", rank: "8" }, { suit: "C", rank: "K" }, { suit: "C", rank: "Q" }, { suit: "C", rank: "9" }, { suit: "C", rank: "8" }, { suit: "C", rank: "5" }, { suit: "C", rank: "2" }],
        W: [{ suit: "S", rank: "K" }, { suit: "S", rank: "Q" }, { suit: "S", rank: "T" }, { suit: "S", rank: "8" }, { suit: "S", rank: "5" }, { suit: "H", rank: "T" }, { suit: "H", rank: "6" }, { suit: "H", rank: "5" }, { suit: "H", rank: "2" }, { suit: "D", rank: "9" }, { suit: "D", rank: "7" }, { suit: "C", rank: "T" }, { suit: "C", rank: "6" }],
      },
      dealer: "E",
      vul: "",
    },
    auction: [
      { seat: "E", call: { level: 1, strain: "H" } },
      { seat: "S", call: { level: 2, strain: "C" } },
      { seat: "W", call: { level: 2, strain: "H" } },
      { seat: "N", call: { level: 4, strain: "N" } },
      { seat: "E", call: { kind: "pass" } },
      { seat: "S", call: { level: 5, strain: "H" } },
      { seat: "W", call: { kind: "pass" } },
      { seat: "N", call: { level: 6, strain: "C" } },
      { seat: "E", call: { kind: "pass" } },
      { seat: "S", call: { kind: "pass" } },
      { seat: "W", call: { kind: "pass" } },
    ],
    contract: { level: 6, strain: "C", declarer: "S", doubled: 0 },
    lead: { seat: "W", card: { suit: "S", rank: "K" } },
    intro: ["Explanation to come."],
    solution: "(Solution to be added.)",
  },
];
